
import CommentIcon from '~/components/ui/icons/CommentIcon.vue';
import RepostIcon from '~/components/ui/icons/RepostIcon.vue';
import ShareIcon from '~/components/ui/icons/ShareIcon.vue';
import { isMobileResponsive } from '~/utils/mixins';
import AnimatedLikeButton from './AnimatedLikeButton.vue';

const SUPPORTED_ALIGNMENTS = ['center', 'left'];

export default {
  name: 'SocialInteraction',
  components: {
    CommentIcon,
    RepostIcon,
    ShareIcon,
    AnimatedLikeButton,
  },
  mixins: [isMobileResponsive],
  props: {
    isLiked: {
      type: Boolean,
      default: false,
    },
    likeCount: {
      type: Number,
      default: -1,
    },
    replyCount: {
      type: Number,
      default: -1,
    },
    repostCount: {
      type: Number,
      default: -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showRepost: {
      type: Boolean,
      default: true,
    },
    showShare: {
      type: Boolean,
      default: true,
    },
    alignmentDirection: {
      type: String,
      default: 'center',
    },
    gap: {
      type: String,
      default: '4',
    },
  },
  emits: ['onLike', 'onReply', 'onRepost', 'onShare'],
  computed: {
    shouldShowPostStats() {
      return this.replyCount > 0 && this.reportCount !== 0;
    },
    resolvedAlignment() {
      if (!SUPPORTED_ALIGNMENTS.includes(this.alignmentDirection)) {
        const supported = SUPPORTED_ALIGNMENTS.join(', ');
        throw new Error(
          `alignmentDirection: unsupported value "${this.alignmentDirection}" - only ${supported} supported for now`
        );
      }
      return this.alignmentDirection;
    },
    containerClass() {
      return {
        center: 'justify-between',
        left: `justify-start gap-${this.gap}`,
      }[this.resolvedAlignment];
    },
    itemWrapperClass() {
      return {
        center: 'flex flex-1 justify-center items-center',
        left: 'flex items-center',
      }[this.resolvedAlignment];
    },
  },
  methods: {
    handleLike() {
      if (!this.disabled) {
        this.$emit('onLike');
      }
    },
  },
};
